import { ACHIEVEMENTS, AchievementType, Sport, TeamBasic, getDefaultSeason, getDefaultYear } from "common";
import { toDateString, convertDateToStringWithoutTime, getCurrentDateWithPadding } from "./date";

export function createStandingsSlug(sport: Sport, year?: string) {
  return `/${sport}/standings/${year || getDefaultYear(sport)}/division`;
}

export function createTeamSlug(sport: Sport, team: TeamBasic) {
  return `/${sport}/teams/${formatNameToUrl(
    team.location ? `${team.location}-${team.name}` : team.name
  )}/${getDefaultYear(sport)}`;
}

export function createPlayerProfileSlug(sport: Sport, id: number): string {
  return `/${sport}/players/${id}`;
}

export function createTeamSlugFromString(sport: Sport, team: string) {
  return `/${sport}/teams/${formatNameToUrl(team)}/${getDefaultYear(sport)}`;
}
export function createLeaderboardSlug(sport: Sport) {
  if (sport && sport !== "all") {
    return `/${sport}/leaderboard`;
  }
  return `/leaderboard`;
}
export function createProfileSlug(username: string): string {
  return `/profile/${username}`;
}

export function createStatsSlug(
  sport: Sport,
  season?: number,
  seasonType?: string
) {
  if (seasonType) {
    return `/${sport}/stats/${season}/${seasonType}`;
  }
  if (season) {
    return `/${sport}/stats/${season}`;
  }
  return `/${sport}/stats/`;
}
export function createGameDetailSlug(sport: Sport, gameId: number): string {
  return `/${sport}/game/${gameId}`;
}
export function createInjuriesSlug(sport: Sport, team?: string) {
  if (team) {
    return `/${sport}/injuries/${team}`;
  }
  return `/${sport}/injuries`;
}
export function createScoresSlug(sport: Sport, date?: string): string {
  return `/${sport}/scores/${date || 
    convertDateToStringWithoutTime(getCurrentDateWithPadding(5))
  }`;
}

export function getTeamNameUrl(team: TeamBasic): string {
  return formatNameToUrl(`${team.location} ${team.name}`);
}
export function formatNameToUrl(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");
}

export function useLastUrl() {
  return localStorage.getItem('lastUrl');
}

export const createAchievementSlug = (type: AchievementType): string => {
  return `/images/bettor/achievements/${ACHIEVEMENTS[type]?.slug}.png`;
}